import { useSpring } from "react-spring";
import { CircularButtonMenu } from "./CircularButtonMenu";
import { bioPink } from "../../constants/constants";
import { springConfigs } from "../../constants/springConfigs";
import { useWindowSize } from "../../hooks/useWindowSize";

export const ArrowComponentMenu = ({
  onClick,
}: {
  onClick: ({
    curtainTo,
    horizontal,
    toLeft,
  }: {
    curtainTo: string;
    horizontal?: boolean | undefined;
    toLeft?: boolean | undefined;
  }) => void;
}) => {
  const { h, w, horizontal }: any = { ...useWindowSize() };

  // border animation
  const { animatedOffset } = useSpring({
    from: { animatedOffset: 1 },
    to: { animatedOffset: 0 },
    config: springConfigs.outlineAppear,
  });
  return (
    <div
      id="ArrowComponentMenu"
      style={{
        display: "grid",
        gridTemplate: horizontal
          ? `
        "left right"
        / 1fr 1.5fr
        `
          : `
        "top" 
        "bottom" 
        / 66%
        `,
        placeContent: "start center",
        gap: horizontal ? w(1) : h(2),
        padding: horizontal ? `0 ${w(3)}` : `0 ${h(0.75)}`,
      }}
    >
      <CircularButtonMenu
        {...{
          animatedOffset,
          color: "white",
          left: true,
          onClick,
          containerStyle: {
            width: "87.5%",
          },
        }}
      />
      <CircularButtonMenu
        {...{
          animatedOffset,
          color: bioPink,
          left: false,
          onClick,
        }}
      />
    </div>
  );
};
